import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from "../../app/apiBaseQuery";
import { getGuestId } from '../Utility';
export const AiApi = createApi({
    reducerPath: 'AiApi',
    baseQuery,
    tagTypes: ['RolePrompts', 'ChatRooms', 'ChatHistory'],
    endpoints: (builder) => ({

        getAllRolePrompts: builder.query({
            query: () => 'ai/getAllRolePrompts',
            providesTags: ['RolePrompts'],
        }),

        saveRolePrompt: builder.mutation({
            query: (body) => ({
                url: 'ai/saveRolePrompt',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['RolePrompts'],
        }),

        startChatRoom: builder.mutation({
            query: (body) => ({
                url: 'ai/startChatRoom',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['ChatRooms'],
        }),

        sendMessage: builder.mutation({
            query: (body) => ({
                url: 'ai/sendMessage',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['ChatHistory', 'ChatRooms'],
        }),

        getChatHistory: builder.query({
            query: (roomId) => `ai/getChatHistory/${roomId}`,
            providesTags: ['ChatHistory'],
        }),

        getUserChatRooms: builder.query({
            query: () => 'ai/getUserChatRooms',
            providesTags: ['ChatRooms'],
        }),
getQuestions: builder.query({
  query: () => ({
    url: '/ai/getQuestions',
    method: 'GET',
  }),
}),
    }),
});

export const {
    useGetAllRolePromptsQuery,
    useSaveRolePromptMutation,
    useStartChatRoomMutation,
    useSendMessageMutation,
    useGetChatHistoryQuery,
    useLazyGetChatHistoryQuery,
    useGetUserChatRoomsQuery,
    useGetQuestionsQuery
} = AiApi;